import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { useConsent } from '../../Context/ConsentContext';
import CookieConsentBanner from '../AnalyticsConsentBanner/CookieConsentBanner';
import { LanguageProvider } from 'Core/Translations/LanguageContext';

const AnalyticsWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { hasConsented, consent } = useConsent();
    const location = useLocation();

    useEffect(() => {
        if (!hasConsented) return;

        const initAnalytics = async () => {
            const config = await import('../../Core/ConfigService').then(mod => mod.default.get());
            ReactGA.initialize(config.Analytics.TrackingId, {
                gaOptions: { cookieFlags: 'max-age=7200;secure;samesite=none' }
            });
        };

        initAnalytics();

    }, [hasConsented]);

    useEffect(() => {
        if (!hasConsented) return;

        ReactGA.set({ page: location.pathname });
        ReactGA.send({ hitType: 'pageview', page: location.pathname, title: document.title });
    }, [location.pathname, hasConsented]);

    return (
        <LanguageProvider>
            {children}
            <CookieConsentBanner />
        </LanguageProvider>
    );
};


export default AnalyticsWrapper;
